export const CONSENT_COOKIE = "__cookie_consent";
export const GTM_EVENT = "cookie_refresh";
